var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccAirlines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Airlines",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8370",
    "data-name": "Rectangle 8370",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35215",
    "data-name": "Group 35215",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35866",
    "data-name": "Path 35866",
    d: "M18.7,3.627c.874-.79,2.548-2.021,3.339-1.406.879.527.44,2.636.088,3.69a8.376,8.376,0,0,1-1.23,2.2c-.615.966-1.23,1.757-1.582,2.373,1.582,2.9,3.163,5.8,4.657,8.7L21.6,22.874c-1.757-2.284-3.6-4.569-5.359-6.854-1.055,1.23-2.2,2.373-3.252,3.6.615,1.493,1.23,2.987,1.757,4.481l-1.317,1.845L9.475,21.728C7.718,21.2,5.96,20.586,4.29,20.058a22.14,22.14,0,0,0,1.23-1.845c1.406-.176,2.9-.352,4.306-.528.615-1.493,1.23-3.075,1.846-4.569-2.548-.528-5.1-.966-7.645-1.494L6.4,7.932l9.051.264c.351-.44.878-1.319,1.582-2.373a18.661,18.661,0,0,1,1.669-2.2",
    transform: "translate(0 0)",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccAirlines);
export default __webpack_public_path__ + "static/media/mcc_airlines.80b16a988d2d010376142c493c5d24c8.svg";
export { ForwardRef as ReactComponent };